import axios from 'lib/axios'

interface Test360GetDraftResponse {
  success: boolean
  message: string
  data?: any
}

const test360GetDraft = async (process_id: number): Promise<Test360GetDraftResponse> => {
  const apiUrl = `/process/draft/${process_id}`

  try {
    const response = await axios.get(apiUrl)
    return response.data
  } catch (error: any) {
    console.error('error getting test 360 draft', error)
    return {
      success: false,
      message: error?.response?.data?.message || 'Error al obtener el borrador Test 360',
      data: error?.response?.data
    }
  }
}

export default test360GetDraft
